var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cta-button',_vm._b({attrs:{"is-inverted":"","tag":_vm.tag,"size":_vm.size,"is-active":_vm.isSelected},on:{"click":function($event){return _vm.$emit('select', $event)}}},'cta-button',_vm.$attrs,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }